import { createClient } from "@supabase/supabase-js";

// Environment detection based on hostname
const hostname = window.location.hostname;
// NOTE (2026-07-07): local dev intentionally routes to PROD, not test.
// Test is back up, but it's a stale/incomplete snapshot — episode 152's
// real story rows (performance_id 1528/1529/1530, the Dokka/Jyotsna/Sujata
// content the Episode Metadata Editor is being used on) only exist in
// prod. Revert this (add localhost/127.0.0.1 back to the isTest check)
// once test has real data to work against, or once you're done editing
// live prod content. Live writes from localhost now hit production —
// same caution as before, this time deliberate rather than a workaround.
const isTest =
  hostname === "test.kathakala.us";

const ENV = {
  test: {
    SUPABASE_URL: "https://iacviushyhogccaomghr.supabase.co",
    SUPABASE_ANON_KEY:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlhY3ZpdXNoeWhvZ2NjYW9tZ2hyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM2MjQwNzgsImV4cCI6MjA4OTIwMDA3OH0.29s0QFFFZ8Q5J2rc6zTsZsoZpytqj3NwmfMok8Gixu8",
  },
  prod: {
    SUPABASE_URL: "https://zxoramsfclwwwltiggox.supabase.co",
    SUPABASE_ANON_KEY:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp4b3JhbXNmY2x3d3dsdGlnZ294Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzIxMTY5NzYsImV4cCI6MjA4NzY5Mjk3Nn0.xYh3P5E-kIt5mQFN9cc17EtYb3s_wThbJR4lli26Wlo",
  },
};

const config = isTest ? ENV.test : ENV.prod;

export const supabase = createClient(
  config.SUPABASE_URL,
  config.SUPABASE_ANON_KEY
);

export const PHOTO_UPLOAD_URL =
  "https://script.google.com/macros/s/AKfycbxl3c5ebqra0TN15-YpJj-RGFPtNK66xl0orGdBTjifqg3NZVHN6RdJ7ME5V3cpVCqubw/exec";

export const VIDEO_UPLOAD_URL = PHOTO_UPLOAD_URL;

export const IS_TEST = isTest;
